/* ns-currency.js · discreet DISPLAY-ONLY currency converter (2026-06-18, rev2).
   The store charges in KWD (no Shopify Payments in Kuwait → no multi-currency checkout).
   This shows the approximate equivalent of a KWD amount in the buyer's currency on PLP + PDP
   + cart, before the (KWD) checkout. Charge is always KWD · every converted value is prefixed
   "≈" and a "charged in KWD" note shows while a non-KWD currency is active.
   rev2: rates are primed SYNCHRONOUSLY (cache → built-in fallback) so conversion never waits on
   a network call (Shopify CSP can block the FX fetch); a live fetch refines rates in the
   background. Changing the currency RELOADS the page (Fahad 2026-06-18) so prices re-render
   cleanly in the chosen currency. Converts any element with data-ns-kwd + the cart price classes.
   Keep LIST in sync with snippets/ns-currency-select.liquid. */
(function () {
  var BASE = 'KWD';
  var LS_CUR = 'ns_cur_v1';
  var LS_FX = 'ns_fx_v1';
  var FX_URL = 'https://open.er-api.com/v6/latest/KWD';
  var LIST = ['KWD', 'SAR', 'AED', 'QAR', 'BHD', 'OMR', 'USD', 'EUR', 'GBP'];
  // Built-in approximate rates (KWD base) · used immediately + whenever the live fetch is blocked.
  var FALLBACK = { KWD: 1, SAR: 12.21, AED: 11.96, QAR: 11.85, BHD: 1.227, OMR: 1.252, USD: 3.26, EUR: 3.02, GBP: 2.56 };
  var rates = FALLBACK;
  var observer = null, deb;

  function getCur() { try { return localStorage.getItem(LS_CUR) || BASE; } catch (e) { return BASE; } }
  function setCur(c) { try { localStorage.setItem(LS_CUR, c); } catch (e) {} }
  function today() { return new Date().toISOString().slice(0, 10); }

  // Prime from fresh cache synchronously (so a return visitor gets exact rates with no flash).
  try { var c = JSON.parse(localStorage.getItem(LS_FX) || 'null'); if (c && c.day === today() && c.rates) rates = c.rates; } catch (e) {}

  function refreshLive() {
    fetch(FX_URL).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.rates) { rates = j.rates; try { localStorage.setItem(LS_FX, JSON.stringify({ day: today(), rates: rates })); } catch (e) {} convertAll(); }
    }).catch(function () {});
  }

  function fmt(code, amt) {
    try { return new Intl.NumberFormat(document.documentElement.lang === 'ar' ? 'ar-u-nu-latn' : 'en', { style: 'currency', currency: code, currencyDisplay: 'code' }).format(amt); }
    catch (e) { return code + ' ' + amt.toFixed(2); }
  }

  // Text-parse surfaces (KWD money text, no data-ns-kwd): NS card grids (.edit__price) + the cart.
  var CART_SEL = '.edit__price, .totals__total-value, .cart-item__final-price, .cart-item__old-price, .cart-item__price-wrapper .price';
  function parseKwd(t) { var s = String(t).replace(/[^0-9.,]/g, '').replace(/,/g, ''); var n = parseFloat(s); return isNaN(n) ? null : n; }

  function applyEl(el, kwd, cur, can) {
    if (cur === BASE || !can) {
      if (el.hasAttribute('data-ns-orig')) { el.innerHTML = el.getAttribute('data-ns-orig'); el.removeAttribute('data-ns-orig'); }
      return;
    }
    if (kwd == null || isNaN(kwd)) return;
    if (!el.hasAttribute('data-ns-orig')) el.setAttribute('data-ns-orig', el.innerHTML);
    el.innerHTML = '≈ ' + fmt(cur, kwd * rates[cur]);
  }

  function convertAll() {
    var cur = getCur(); var can = (cur !== BASE && rates && rates[cur]);
    if (observer) observer.disconnect();
    document.querySelectorAll('[data-ns-kwd]').forEach(function (el) {
      applyEl(el, parseFloat(String(el.getAttribute('data-ns-kwd')).replace(/,/g, '')), cur, can);
    });
    document.querySelectorAll(CART_SEL).forEach(function (el) {
      if (el.hasAttribute('data-ns-kwd')) return;
      var src = el.hasAttribute('data-ns-orig') ? el.getAttribute('data-ns-orig') : el.innerHTML;
      applyEl(el, parseKwd(src), cur, can);
    });
    document.querySelectorAll('select[data-ns-cur-select]').forEach(function (s) { if (s.value !== cur) s.value = cur; });
    document.querySelectorAll('[data-ns-note]').forEach(function (n) { n.hidden = !(cur !== BASE && can); });
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }
  function debConvert() { clearTimeout(deb); deb = setTimeout(convertAll, 140); }

  window.NSCurrency = { setCurrency: function (c) { setCur(c); convertAll(); }, refresh: convertAll, list: LIST };

  function init() {
    document.querySelectorAll('select[data-ns-cur-select]').forEach(function (s) {
      s.value = getCur();
      // Changing currency persists the choice and reloads · prices re-render in it on load.
      s.addEventListener('change', function () { if (s.value === getCur()) return; setCur(s.value); window.location.reload(); });
    });
    if ('MutationObserver' in window) observer = new MutationObserver(debConvert);
    convertAll();   // rates primed synchronously → converts immediately, no network wait
    refreshLive();  // refine with live rates in the background
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
